import * as THREE from 'three';

export function initScene() {
  /**
   * 场景
   */
  const scene = new THREE.Scene();
  return scene;
}
